import { TmdxResourceCard } from '@features/components/ResourceCards';

type CrewMemberGroundCardProps = {
  title: string;
  subTitle: string;
  imagePath?: string;
};

export const CrewMemberGroundCard = ({ title, subTitle, imagePath }: CrewMemberGroundCardProps) => {
  return (
    <TmdxResourceCard
      size="sm"
      label="Crew Member Ground"
      list={[]}
      type="user"
      title={title}
      subTitle={subTitle}
      showChip={false}
      isReadOnly
      menuDisabled
      cardClassNames="min-w-full"
      avatarProps={{
        type: 'user',
        src: imagePath,
      }}
    />
  );
};
